import Common from "./common";
import Trading from "./trading";
import Wallet from "./wallet";
import Tooltip from "./tooltip";
import Profile from "./profile";
import Error from "./error";
import History from "./history";
import Settings from "./settings";
import Auth from "./auth";
import Main from "./main";
import Seo from "./seo";
import Futures from "./futures";
import VerificationSteps from "./verification-steps";
import Markets from "./markets";
import TradingProfile from "./trading-profile";
import Deposit from "./deposit";
import config from "../config";

/*
  Для того, щоб додати новий блок перекладу - створюєте новий файл на модуль,
  а далі підключаєте його у TranslationsArray нижче.
*/

const TranslationsArray = [
  Common,
  Trading,
  Wallet,
  Tooltip,
  Profile,
  Error,
  Settings,
  History,
  Auth,
  Main,
  Seo,
  Futures,
  VerificationSteps,
  Markets,  
  TradingProfile,
  Deposit,
];

const finalTranslations = {};

const supportedLangs = config.supported_locales;

// Додаємо всі мови, які є в перекладах, навіть якщо вони не в config.supported_locales
const allAvailableLangs = new Set(supportedLangs);
TranslationsArray.forEach((translationBlock) => {
  Object.keys(translationBlock).forEach((lang) => {
    if (lang !== 'default') {
      allAvailableLangs.add(lang);
    }
  });
});

Array.from(allAvailableLangs).forEach((locale) => {
  finalTranslations[locale] = {};
});

TranslationsArray.forEach((translationBlock) => {
  Array.from(allAvailableLangs).forEach((lang) => {
    if (translationBlock[lang]) {
      finalTranslations[lang] = {
        ...finalTranslations[lang],
        ...translationBlock[lang],
      };
    }
  });
});

export default finalTranslations;
